'use client';

import { LazyLoadImage } from '@depop/web-ui-kit/LazyLoadImage';
import { useTranslations } from 'next-intl';

import { ProductCard } from '@/components/ProductCard';
import { ProductCardAttributes } from '@/components/ProductCardAttributes';
import {
  buildProductImageProps,
  picturePreviewAdapter,
} from '@/modules/pictures/helpers';
import { type BasedOnRecentViewsRecommendationsProduct } from '@/modules/product/aliases';
import { type ProductPicture } from '@/modules/product/types';

type Props = {
  product: BasedOnRecentViewsRecommendationsProduct;
  onClick?: (product: BasedOnRecentViewsRecommendationsProduct) => void;
};

export function BasedOnRecentViewsProductCard({
  product,
  onClick = () => null,
}: Props) {
  const t = useTranslations('common');

  const pictures = (product.pictures ?? []) as ProductPicture[];
  const preview = pictures[0] ? picturePreviewAdapter(pictures[0]) : {};
  const hasMoreThanOnePicture = pictures.length > 1;
  const [sellerUsername] = product.slug.split('-');
  const sizes =
    product.sizes?.map((s) => s.name).filter((n): n is string => !!n) ?? [];

  return (
    <ProductCard
      productHref={product.slug}
      preview={preview}
      sellerUserName={sellerUsername}
      handleClick={() => onClick(product)}
      ProductAttributes={() => (
        <ProductCardAttributes
          sizes={sizes}
          brandName={product.brand_name || t('Other')}
          displayPrice={product.pricing.display_price}
        />
      )}
      {...(hasMoreThanOnePicture && {
        HoverOverlay: () => (
          <LazyLoadImage
            {...buildProductImageProps({
              preview: picturePreviewAdapter(pictures[1]),
              sellerUserName: sellerUsername,
            })}
          />
        ),
      })}
    />
  );
}
